import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    IconButton,
    makeStyles,
    Slide,
    Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Searchbar from '../Searchbar';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchShiftUsersList,
    cancelDedicatedSlotOps,
} from '../../store/actions/settingsActionCreator';
import { showMessage } from '../../utils/helper';
import { Spinner } from '../UI';
import InfiniteScroll from 'react-infinite-scroll-component';
import ShiftColumnItemPopper from '../Containers/ShiftColumnItemPopper';
import PersonIcon from '@material-ui/icons/Person';
import AssignStaffToHubModal from './AssignStaffToHubModal';
import { CloseIcon } from '../../assets/svg';
import { TransitionProps } from '@material-ui/core/transitions';
import { FormatTime } from '../../utils/appHelper';
import { canAssignStaff } from '../../utils/permissions';

interface SlotDetailModalProps {
    hubInfo: any; // Replace with proper type
    open: boolean;
    onClose: () => void;
    data: any; // Replace with proper type
    openEditModal?: () => void;
    openDeleteModal?: () => void;
    isEdit?: boolean;
    permissions?: any;
}

interface ShiftUserPayload {
    shiftIds: string[];
    searchText: string;
    pageNo: number;
    pageSize: number;
}

const useStyles = makeStyles((theme) => ({
    modal: {
        '& .modal-head': {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
        },
        '& .modal-title': {
            fontSize: '18px',
            fontWeight: 600,
            color: '#14112d',
            marginBottom: 6,
        },
        '& .modal-subtitle': {
            fontSize: '14px',
            fontWeight: 600,
            color: '#14112d',
        },
        '& .cancelButton': {
            color: theme.palette.text.primary,
        },
        '& .leaflet-container': {
            width: '100%',
            height: '510px',
            borderTopRightRadius: 16,
            borderBottomRightRadius: 16,
        },
    },
    iconButton: {
        padding: '0px',
    },
}));

const Transition = React.forwardRef<
    unknown,
    TransitionProps & { children?: React.ReactElement<any, any> }
>(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SlotDetailModal: React.FC<SlotDetailModalProps> = ({
    hubInfo,
    open,
    onClose,
    data,
    openEditModal,
    openDeleteModal,
    isEdit,
    permissions,
    ...props
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { shiftUsers } = useSelector((state: any) => state?.settings);
    const enableOpsCancelSlot = useSelector(
        (state: any) => !!state?.user?.config?.enableOpsCancelSlot,
    );
    const adminUserId = useSelector((state: any) => state?.user?.id);

    const [isOpen, toggleModal] = useState(open);
    const [staffModalOpen, setStaffModalOpen] = useState(false);
    const [shiftUserPayload, setShiftUserPayload] = useState<ShiftUserPayload>({
        shiftIds: [data?.id],
        searchText: '',
        pageNo: 1,
        pageSize: 10,
    });
    const [loading, toggleLoading] = useState(false);
    const [userList, setUserList] = useState<any[]>([]); // Replace 'any' with proper type
    const [cancellingUserId, setCancellingUserId] = useState<number | null>(
        null,
    );

    const handleCancelOpsSlot = (item: any) => {
        const userId = item?.id;
        if (!userId || !data?.id) return;
        setCancellingUserId(userId);
        dispatch(
            cancelDedicatedSlotOps(
                {
                    adminUser: adminUserId,
                    userId,
                    slotIds: [data?.id],
                },
                () => {
                    setCancellingUserId(null);
                    showMessage('Slot cancelled successfully', 'success');
                    setUserList([]);
                    setShiftUserPayload({
                        ...shiftUserPayload,
                        pageNo: 1,
                    });
                },
                () => {
                    setCancellingUserId(null);
                },
            ),
        );
    };

    const fetchUsersForShift = async (payload: ShiftUserPayload) => {
        toggleLoading(true);
        try {
            dispatch(
                fetchShiftUsersList(payload, (response: any) => {
                    setUserList(
                        !!shiftUserPayload?.searchText ||
                            shiftUserPayload?.pageNo === 1
                            ? [...response?.response?.lineItems]
                            : [...userList, ...response?.response?.lineItems],
                    );
                }),
            );
        } catch (err) {
        } finally {
            toggleLoading(false);
        }
    };

    const handleClose = () => {
        toggleModal(false);
        onClose?.();
    };

    useEffect(() => {
        toggleModal(open);
    }, [open]);

    useEffect(() => {
        fetchUsersForShift(shiftUserPayload);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shiftUserPayload]);
    console.log('userList sssss', data);
    return (
        <>
            <Dialog
                open={isOpen}
                //TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={classes.modal}
                fullWidth={true}
                maxWidth={'sm'}
            >
                <Spinner loading={loading}>
                    <DialogTitle
                        style={{
                            height: '80vh',
                            overflow: 'hidden',
                            padding: 0,
                        }}
                    >
                        <Box
                            className="modal-head"
                            style={{ padding: '16px 24px' }}
                        >
                            <div>
                                <Typography className="modal-title">
                                    {data?.name}
                                </Typography>
                                <Typography
                                    className="modal-subtitle"
                                    variant="body2"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                    }}
                                >
                                    {hubInfo?.name}
                                    <Box style={{ padding: 7 }}>
                                        <Box
                                            style={{
                                                width: 4,
                                                height: 4,
                                                backgroundColor:
                                                    'rgba(0, 0, 0, 0.16)',
                                                borderRadius: 50,
                                            }}
                                        />
                                    </Box>
                                    {FormatTime(data?.startTime ?? '')}{' '}
                                    to{' '}
                                    {FormatTime(data?.endTime ?? '')}
                                    <Box style={{ padding: 7 }}>
                                        <Box
                                            style={{
                                                width: 4,
                                                height: 4,
                                                backgroundColor:
                                                    'rgba(0, 0, 0, 0.16)',
                                                borderRadius: 50,
                                            }}
                                        />
                                    </Box>
                                    {'Staff Count: '}
                                    <span
                                        style={{
                                            fontWeight: 600,
                                            marginLeft: 2,
                                        }}
                                    >
                                        {data?.staffCount}
                                    </span>
                                </Typography>
                            </div>
                            <div
                                style={{
                                    alignSelf: 'center',
                                    justifySelf: 'flex-end',
                                }}
                            >
                                <IconButton
                                    aria-label="delete"
                                    className={classes.iconButton}
                                    onClick={handleClose}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </Box>
                        <Box
                            style={{
                                margin: '0 24px',
                                marginTop: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Searchbar
                                dataSource={userList}
                                keys={['name', 'contactNumber']}
                                value={shiftUserPayload.searchText}
                                backendSearchbar={true}
                                onBackendSearch={(val: string) => {
                                    setUserList([]);
                                    setShiftUserPayload({
                                        ...shiftUserPayload,
                                        searchText: val,
                                    });
                                }}
                                placeHolderText="Search FEs"
                                style={{
                                    color: '#14112d',
                                    width: '74%',
                                }}
                                onChange={(val: any) => {
                                    setUserList([]);
                                    setShiftUserPayload({
                                        ...shiftUserPayload,
                                        searchText: val,
                                    });
                                }}
                                onFilter={() => {
                                    console.log('search bar filtering');
                                }}
                            />
                            <Button
                                variant="outlined"
                                style={{ fontSize: 14 }}
                                color="primary"
                                onClick={() => setStaffModalOpen(true)}
                                startIcon={<PersonIcon fontSize="small" />}
                                disableElevation
                                disabled={
                                    !canAssignStaff(permissions) ||
                                    data?.slotShift
                                }
                            >
                                {'Assign Staff'}
                            </Button>
                        </Box>
                        <div
                            id="scrollableDiv"
                            style={{
                                height: '60vh',
                                overflow: 'auto',
                                width: '100%',
                                padding: '16px 24px',
                                paddingTop: 0,
                            }}
                        >
                            <InfiniteScroll
                                scrollableTarget="scrollableDiv"
                                dataLength={userList.length}
                                next={() => {
                                    setShiftUserPayload({
                                        ...shiftUserPayload,
                                        pageNo: shiftUserPayload.pageNo + 1,
                                    });
                                }}
                                hasMore={
                                    userList.length < shiftUsers?.totalCount
                                }
                                loader={<h6>Loading...</h6>}
                                endMessage={
                                    <p style={{ textAlign: 'center' }}></p>
                                }
                            >
                                {userList?.length ? (
                                    userList.map((item, idx) => (
                                        <Box
                                            key={`${item?.userName}${idx}`}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                padding: '6px 16px',
                                                border: '1px solid #efefef',
                                                borderRadius: 8,
                                                marginTop: 8,
                                                width: '100%',
                                            }}
                                        >
                                            <Box
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    width: '60%',
                                                }}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    style={{
                                                        fontSize: 14,
                                                        fontWeight: 600,
                                                        color: '#14112d',
                                                    }}
                                                >
                                                    {item?.name}
                                                </Typography>
                                                <Box style={{ padding: 7 }}>
                                                    <Box
                                                        style={{
                                                            width: 4,
                                                            height: 4,
                                                            backgroundColor:
                                                                'rgba(0, 0, 0, 0.16)',
                                                            borderRadius: 50,
                                                        }}
                                                    />
                                                </Box>
                                                <Typography
                                                    variant="body1"
                                                    style={{
                                                        fontSize: 14,
                                                        fontWeight: 600,
                                                        color: '#808080',
                                                    }}
                                                >
                                                    {item?.contactNumber}
                                                </Typography>
                                            </Box>
                                            <Box
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    width: '40%',
                                                }}
                                            >
                                                <ShiftColumnItemPopper
                                                    limit={1}
                                                    data={item}
                                                    selectedItem={{}}
                                                    setSelectedItem={undefined}
                                                    labelStyle={undefined}
                                                    fromScreen={''}
                                                />
                                                {enableOpsCancelSlot && (
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        style={{
                                                            fontSize: 12,
                                                            fontWeight: 600,
                                                            marginLeft: 8,
                                                            color: '#F44336',
                                                            borderColor:
                                                                '#F44336',
                                                        }}
                                                        disabled={
                                                            cancellingUserId ===
                                                            item?.id
                                                        }
                                                        onClick={() =>
                                                            handleCancelOpsSlot(
                                                                item,
                                                            )
                                                        }
                                                    >
                                                        {'Cancel'}
                                                    </Button>
                                                )}
                                            </Box>
                                        </Box>
                                    ))
                                ) : (
                                    <Box
                                        style={{
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '11px 16px',
                                            border: '1px solid #efefef',
                                            borderRadius: 8,
                                            margin: '8px 0',
                                            width: '100%',
                                            minHeight: '50vh',
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            style={{ color: '#14112d' }}
                                        >
                                            FE not Assigned yet
                                        </Typography>
                                    </Box>
                                )}
                            </InfiniteScroll>
                        </div>
                    </DialogTitle>
                </Spinner>
            </Dialog>
            {staffModalOpen && (
                <AssignStaffToHubModal
                    open={staffModalOpen}
                    data={{
                        ...hubInfo,
                        shift: data,
                    }}
                    onClose={() => {
                        setStaffModalOpen(false);
                        setShiftUserPayload({
                            shiftIds: [data?.id],
                            searchText: '',
                            pageNo: 1,
                            pageSize: 10,
                        });
                    }}
                />
            )}
        </>
    );
};

export default SlotDetailModal;
